export var EventName;
(function (EventName) {
    EventName["ProviderFilteringOptionChanged"] = "ProviderFilteringOptionChanged";
    EventName["FeeBreakdownPopoverStarted"] = "FeeBreakdownPopoverStarted";
    EventName["MobileFeeBreakdownStarted"] = "MobileFeeBreakdownStarted";
    EventName["LargestProviderTableRendered"] = "LargestProviderTableRendered";
    EventName["RowWasSeen"] = "RowWasSeen";
    EventName["WiseHasHiddenFee"] = "WiseHasHiddenFee";
})(EventName || (EventName = {}));
export var WidgetName;
(function (WidgetName) {
    WidgetName["TransferFeeComparison"] = "Transfer-Fee-Comparison";
})(WidgetName || (WidgetName = {}));
export var Table;
(function (Table) {
    Table["ProviderComparison"] = "Provider Comparison";
    Table["Hero"] = "Hero";
    Table["Educational"] = "Educational";
    Table["TransferFee"] = "Transfer Fee";
    Table["HeroV2"] = "HeroV2";
    Table["ComparisonV2"] = "ComparisonV2";
})(Table || (Table = {}));
export var TableEvent;
(function (TableEvent) {
    TableEvent["AMOUNT_CHANGED"] = "AMOUNT_CHANGED";
    TableEvent["CURRENCIES_SWAPPED"] = "CURRENCIES_SWAPPED";
    TableEvent["DELIVERY_ESTIMATOR_CLICKED"] = "DELIVERY_ESTIMATOR_CLICKED";
    TableEvent["DISCLAIMER_CLICKED"] = "DISCLAIMER_CLICKED";
    TableEvent["FEE_BREAKDOWN_POPOVER_CLICKED"] = "FEE_BREAKDOWN_POPOVER_CLICKED";
    TableEvent["PRICING_DISCLAIMER_CLICKED"] = "PRICING_DISCLAIMER_CLICKED";
    TableEvent["PROVIDER_CLICKED"] = "PROVIDER_CLICKED";
    TableEvent["QUOTES_LOADED"] = "QUOTES_LOADED";
    TableEvent["SEE_AVAILABLE_COMPARISON_CLICKED"] = "SEE_AVAILABLE_COMPARISON_CLICKED";
    TableEvent["SEND_MONEY_CTA_CLICKED"] = "SEND_MONEY_CTA_CLICKED";
    TableEvent["SOURCE_CURRENCY_CHANGED"] = "SOURCE_CURRENCY_CHANGED";
    TableEvent["TABLE_VIEWED"] = "TABLE_VIEWED";
    TableEvent["TARGET_CURRENCY_CHANGED"] = "TARGET_CURRENCY_CHANGED";
    TableEvent["UNSUPPORTED_AMOUNT"] = "UNSUPPORTED_AMOUNT";
    TableEvent["UNSUPPORTED_ROUTE"] = "UNSUPPORTED_ROUTE";
    TableEvent["WISE_IS_NOT_THE_CHEAPEST"] = "WISE_IS_NOT_THE_CHEAPEST";
    TableEvent["WISE_IS_NOT_THE_FASTEST"] = "WISE_IS_NOT_THE_FASTEST";
    TableEvent["EXPAND_ROW_CLICKED"] = "EXPAND_ROW_CLICKED";
})(TableEvent || (TableEvent = {}));
export const EventNames = {
    [TableEvent.AMOUNT_CHANGED]: {
        gtm: 'comparison_amount_changed',
        mixpanel: 'Comparison - Amount Changed',
    },
    [TableEvent.CURRENCIES_SWAPPED]: {
        gtm: 'comparison_currencies_swapped',
        mixpanel: 'Comparison - Currencies Swapped',
    },
    [TableEvent.DELIVERY_ESTIMATOR_CLICKED]: {
        gtm: 'comparison_delivery_estimator_clicked',
        mixpanel: 'Comparison - Delivery Estimator Clicked',
    },
    [TableEvent.DISCLAIMER_CLICKED]: {
        gtm: 'comparison_disclaimer_clicked',
        mixpanel: 'Comparison - Disclaimer Clicked',
    },
    [TableEvent.EXPAND_ROW_CLICKED]: {
        gtm: 'comparison_expand_row_clicked',
        mixpanel: 'Comparison - Expand Row Clicked',
    },
    [TableEvent.FEE_BREAKDOWN_POPOVER_CLICKED]: {
        gtm: 'comparison_fee_breakdown_popover_clicked',
        mixpanel: 'Comparison - Fee Breakdown Popover Clicked',
    },
    [TableEvent.PRICING_DISCLAIMER_CLICKED]: {
        gtm: 'comparison_pricing_disclaimer_clicked',
        mixpanel: 'Comparison - Pricing Disclaimer Clicked',
    },
    [TableEvent.PROVIDER_CLICKED]: {
        gtm: 'comparison_provider_clicked',
        mixpanel: 'Comparison - Provider Clicked',
    },
    [TableEvent.QUOTES_LOADED]: {
        gtm: 'comparison_quotes_loaded',
        mixpanel: 'Comparison - Quotes Loaded',
    },
    [TableEvent.SEE_AVAILABLE_COMPARISON_CLICKED]: {
        gtm: 'comparison_see_available_comparison_clicked',
        mixpanel: 'Comparison - See Available Comparison Clicked',
    },
    [TableEvent.SEND_MONEY_CTA_CLICKED]: {
        gtm: 'comparison_send_money_cta_clicked',
        mixpanel: 'Comparison - Send Money CTA Clicked',
    },
    [TableEvent.SOURCE_CURRENCY_CHANGED]: {
        gtm: 'comparison_source_currency_changed',
        mixpanel: 'Comparison - Source Currency Changed',
    },
    [TableEvent.TABLE_VIEWED]: {
        gtm: 'comparison_table_viewed',
        mixpanel: 'Comparison - Table Viewed',
    },
    [TableEvent.TARGET_CURRENCY_CHANGED]: {
        gtm: 'comparison_target_currency_changed',
        mixpanel: 'Comparison - Target Currency Changed',
    },
    [TableEvent.UNSUPPORTED_AMOUNT]: {
        gtm: 'comparison_amount_unsupported',
        mixpanel: 'Comparison - Amount Unsupported',
    },
    [TableEvent.UNSUPPORTED_ROUTE]: {
        gtm: 'comparison_route_unsupported',
        mixpanel: 'Comparison - Route Unsupported',
    },
    [TableEvent.WISE_IS_NOT_THE_CHEAPEST]: {
        gtm: 'comparison_wise_is_not_the_cheapest',
        mixpanel: 'Comparison - Wise Is Not The Cheapest',
    },
    [TableEvent.WISE_IS_NOT_THE_FASTEST]: {
        gtm: 'comparison_wise_is_not_the_fastest',
        mixpanel: 'Comparison - Wise Is Not The Fastest',
    },
};
